module.exports = __webpack_public_path__ + "img/shop-accessories.c96f44c1.jpg";